export default {
  NONE: {
    label: 'questionnaire.options.global.none',
    value: 'none',
    exclusive: true
  }
};
